import GridMasonry from "./gridMasonry";
import Breakpoint from "./breakpoint";
import Slider from "./slider";

export default (el) => {
    const masonry = new GridMasonry(".highlights", ".card-dynamic-articles");
    const breakpoint =  new Breakpoint(1024);
    const slider = new Slider(el.querySelector('.slider'));
    
    breakpoint.under = () => {
        masonry.destroy();
        slider.create();
        // conditioner.hydrate(el);

        el.querySelector('.btn-prev').onclick = () => slider.prev();
        el.querySelector('.btn-next').onclick = () => slider.next();
    }
    breakpoint.above = () => {
        slider.destroy();
        masonry.column(3);
        // conditioner.hydrate(el);
    }
   
};
